import React from 'react'

import styles from './Tag.module.scss'
import { ColorHexToRgbWithAlpha } from 'helpers/converters.helper'

interface ITagProps {
  text: any
  color: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const Tag: React.FC<ITagProps> = ({ text, color, size, className = '' }) => {
  const sizeStyle = (size: any) => {
    const sizeStyles: { [key: string]: string } = { sm: styles.tagSm, md: styles.tagMd, lg: styles.tagLg }
    return size ? sizeStyles[size] : styles.tagMd
  }
  const colorPicked = color ? color : 'aaa9a9'
  return (
    <div className={`${styles.tag} ${sizeStyle(size)} ${className}`} style={ColorHexToRgbWithAlpha(colorPicked, 0.25)}>
      {text}
    </div>
  )
}

export default Tag
